import { writable } from 'svelte/store';
export let date = writable(new Date());
export let night = writable(1);
export let guest = writable(1);
export let name = writable('');
export let type = writable(null);
export let price = writable('');
export let shoppingCategory = writable('');
// let store;
// export default store = {
//     data: {
//         date: { subscribe: date.subscribe },
//         night: { subscribe: night.subscribe },
//         guest: { subscribe: guest.subscribe },
//     },
// };
